import IconType from "@/components/IconType";
import { BLOOD_ICON_TYPE, SIMPLE_DNA_ICON_TYPE } from "@/core/constants";
import PenIcon from "@/images/PenIcon";
import Group from "@/tpo/Group";

import { SpanText } from "../Text";
import { formatMarkerCount } from "./variantStyles";

const MARKER_CONFIG = {
  functional: {
    iconType: BLOOD_ICON_TYPE,
    label: "functional:"
  },
  dna: {
    iconType: SIMPLE_DNA_ICON_TYPE,
    label: "snp's:"
  },
  symptoms: {
    usePenIcon: true,
    label: "symptoms"
  }
};

export function ReportListCardMarkerItem({
  type,
  count,
  userCount,
  color = "dark"
}) {
  const config = MARKER_CONFIG[type];

  return (
    <Group gap={8}>
      {config.usePenIcon ? (
        <PenIcon fill={color} withBottomLine={false} size={20} />
      ) : (
        <IconType iconType={config.iconType} withCircle={false} iconSize={20} color={color} />
      )}
      <SpanText
        fontFamily="gilroyBold"
        fontSize={12}
        letterSpacing="2.8px"
        textTransform="uppercase"
        color={color}
      >
        {config.label}
      </SpanText>
      <SpanText fontFamily="gilroyMedium" fontSize={12} color={color}>
        {formatMarkerCount(userCount, count)}
      </SpanText>
    </Group>
  );
}
